module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-1ff3d940!./packages/dof-badge/colmo.css
// module id = 445
// module chunks = 0 1